import { useCallback } from 'react';
import { RestAPIEndpoints } from '@lifeomic/react-client';
import { apiHooks } from './useRestAPIHooks';

export type SendAgentFeedbackRequest =
  RestAPIEndpoints['POST /v1/agents-v2/feedback']['Request'];

export type SendAgentFeedbackInput = {
  feedback: SendAgentFeedbackRequest['feedback'];
  agentName: SendAgentFeedbackRequest['agent_name'];
  traceId: SendAgentFeedbackRequest['trace_id'];
  score?: SendAgentFeedbackRequest['score'];
  scoreName?: SendAgentFeedbackRequest['score_name'];
};

/** POST `/v1/agents-v2/feedback` via camelCase input → request body mapping. */
export function useSendAgentFeedback() {
  const sendFeedbackMutation = apiHooks.useAPIMutation(
    'POST /v1/agents-v2/feedback',
  );
  const sendAgentFeedback = useCallback(
    ({
      feedback,
      agentName,
      traceId,
      score,
      scoreName,
    }: SendAgentFeedbackInput) => {
      const body: SendAgentFeedbackRequest = {
        feedback,
        agent_name: agentName,
        trace_id: traceId,
        ...(score !== undefined ? { score } : {}),
        ...(scoreName !== undefined ? { score_name: scoreName } : {}),
      };
      return sendFeedbackMutation.mutateAsync(body);
    },
    [sendFeedbackMutation],
  );
  return { sendAgentFeedback };
}
